import { UseCaseDefinitions } from "../../contexts/permissionsContext";
import { httpGet, httpPost } from "../httpService/httpService";
import { NotificationMarker, NotificationTemplate, NotificationTemplatesResponse, PortalGroupResponse } from "./types/administrationServiceTypes";

export const getNotificationTemplates = async (apiBase: string): Promise<NotificationTemplatesResponse> => {
    return new Promise((resolve, reject) => (
        httpGet(`${apiBase}/administration/notification-templates`)
            .then((res: any) => {
                resolve(res.data as NotificationTemplatesResponse);
            })
            .catch((error: any) => {
                reject(error);
            })
    ));
}

export const getMarkers = async (apiBase: string, category: string): Promise<NotificationMarker[]> => {
    return new Promise((resolve, reject) => (
        httpGet(`${apiBase}/administration/get-markers?category=${category}`)
            .then((res: any) => {
                resolve(res.data as NotificationMarker[]);
            })
            .catch((error: any) => {
                reject(error);
            })
    ));
}

export const getReceiverGroups = async (apiBase: string, id: number): Promise<PortalGroupResponse> => {
    return new Promise((resolve, reject) => (
        httpGet(`${apiBase}/administration/${id}/get-notification-receiver-groups`)
            .then((res: any) => {
                resolve(res.data as PortalGroupResponse);
            })
            .catch((error: any) => {
                reject(error);
            })
    ));
}

export const saveNotificationTemplate = async (apiBase: string, template: NotificationTemplate): Promise<boolean> => {
    return new Promise((resolve, reject) => (
        httpPost(`${apiBase}/administration/${template.id}/update-notification-template`, template)
            .then((res: any) => {
                resolve(true);
            })
            .catch((error: any) => {
                reject(error);
            })
    ));
}

export const saveNotificationReceiverGroups = async (apiBase: string, templateId: number, groupIds: number[]): Promise<boolean> => {
    return new Promise((resolve, reject) => (
        httpPost(`${apiBase}/administration/${templateId}/update-notification-receiver-groups`, groupIds)
            .then((res: any) => {
                resolve(res.data as boolean);
            })
            .catch((error: any) => {
                reject(error);
            })
    ));
}

export const getUserNotificationConfig = async (apiBase: string, userId: string) => {

    return new Promise((resolve, reject) => {
        httpGet(`${apiBase}/administration/${userId}/get-user-notification-config`)
        .then((res: any) => {
            resolve(res.data);
        })
        .catch((error: any) => {
            reject(error);
        })
    })
}

export const saveEmailNotificationUserConfig = async (apiBase: string, notifyByEmail: boolean, userId: string) => {

    const formData = new FormData();
    formData.append('NotifyByEmail', notifyByEmail.toString());
    formData.append('UserId', userId);

    return new Promise((resolve, reject) => {
        httpPost(`${apiBase}/administration/update-email-notification-user-config`, formData)
        .then((res: any) => {
            resolve(res.data);
        })
        .catch((error: any) => {
            reject(error);
        })
    })
}

export const getRoleDefinitions = async (apiBase: string) => {
    return new Promise((resolve, reject) => (
        httpGet(`${apiBase}/administration/get-role-definitions`)
            .then((res: any) => {
                resolve(res.data);
            })
            .catch((error: any) => {
                reject(error);
            })
    ));
}

export const saveRoleDefinitions = async (apiBase: string, useCaseDefinitions: UseCaseDefinitions[]) => {

    const formData = new FormData();
    formData.append('UseCaseDefinitions', JSON.stringify(useCaseDefinitions));

    return new Promise((resolve, reject) => {
        httpPost(`${apiBase}/administration/save-role-definitions`, formData)
        .then((res: any) => {
            resolve(res.data);
        })
        .catch((error: any) => {
            reject(error);
        })
    })
}

export const getUserExtendedPermissions = async (apiBase: string, userId: any, withTerytDicts: boolean) => {
    return new Promise((resolve, reject) => (
        httpGet(`${apiBase}/administration/${userId}/${withTerytDicts}/get-user-extended-permissions`)
            .then((res: any) => {
                resolve(res.data);
            })
            .catch((error: any) => {
                reject(error);
            })
    ));
}

export const saveExtendedUserPermissions = async (apiBase: string, userId: string, assignedObjectCategories: string[], assignedTeryts: string[]) => {

    const formData = new FormData();
    formData.append('UserId', userId);
    formData.append('AssignedObjectCategories', JSON.stringify(assignedObjectCategories));
    formData.append('AssignedTeryts', JSON.stringify(assignedTeryts));

    return new Promise((resolve, reject) => {
        httpPost(`${apiBase}/administration/save-user-extended-permissions`, formData)
        .then((res: any) => {
            resolve(res.data);
        })
        .catch((error: any) => {
            reject(error);
        })
    })
}

export const getExtendedUsers= async (apiBase: string) => {

    return new Promise((resolve, reject) => {
        httpGet(`${apiBase}/administration/get-extended-users`)
        .then((res: any) => {
            resolve(res.data);
        })
        .catch((error: any) => {
            reject(error);
        })
    })
}